<template>
  <div class="layout-inner explore_entity_result employer_board">
    <navbar></navbar>
    <div class="layout-container">
      <div class="layout-content">
        <template v-if="!isSortPanelOpen">
          <div class="sub_hd_bar">
            <div class="sub_hd_ic"></div>
            <div class="srh_bx">
              <input type="text" class="search-input" :placeholder="$t('typeToNarrowResults')" v-on:keyup.enter="searchButtonClicked" v-model.trim="searchTerms"/>
              <span @click="searchButtonClicked" class="search-icon">
                <i class="fa fa-search" aria-hidden="true"></i>
              </span>
            </div>
            <div class="sort_by" @click="openSortPanel">
              <span class="sort_by_link">{{ $t('sort') }}</span>
            </div>
            <div class="list_info">
              {{ $t('exploringEmployers', { total: total }) }}
            </div>
          </div>
        </template>

        <div class="container-fluid flex-grow-1 pg_content_container" style="padding-top: 0px;">
          <template v-if="isSortPanelOpen">
            <div class="container filter_selection_flds_container">
              <div class="filter_fld_head">
                <div class="hd_txt">{{ $t('sortBy') }}</div>
              </div>
              <div class="mt-2 ml-4">
                <div class="field-row mb-3" v-for="sort in sorts" :key="sort.name">
                  <div class="form-check">
                    <input type="radio" class="form-check-input" :id="'employer-sort-' + sort.name" v-model="selectedSortName" :value="sort.name">
                    <label class="form-check-label" :for="'employer-sort-' + sort.name">{{ sort.labelKey ? $t(sort.labelKey) : sort.name }}</label>
                  </div>
                </div>
                <div class="btn_container">
                  <b-btn @click="sortOkClicked">{{ $t('ok') }}</b-btn>
                </div>
              </div>
            </div>
          </template>

          <template v-else>
            <template v-if="isResultsLoaded">
              <template v-if="results && results.length > 0">
                <div class="job-result-row" v-for="(result, index) in results" :key="result.uuid" @click="goToEmployerDetail(result)">
                  <div class="job-result-main">
                    <div class="job-title-row">
                      <span class="job-title">{{ result.displayName }}</span>
                      <span
                        class="ic_bm_container ace_sec_txt"
                        :class="{ bookmarked: isEmployerBookmark(result) }"
                        v-if="isBookmarkEnabled"
                        @click.stop="toggleEmployerBookmark(result)">
                        <span class="ic ic8-bookmark3"></span>
                      </span>
                    </div>
                    <div class="job-employer">
                      <div
                        class="employer-avatar"
                        :class="{ 'has-logo': result.logo }"
                        :style="result.logo ? null : { background: avatarColor(index) }">
                        <img v-if="result.logo" :src="result.logo" :alt="result.displayName || ''">
                        <span v-else>{{ employerInitials(result.displayName) }}</span>
                      </div>
                      <div class="employer-job-count">
                        <span class="icon-briefcase meta-icon" aria-hidden="true"></span>
                        <span>{{ jobPostedCount(result) }} {{ $t('jobs') }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="job-pagination">
                  <button type="button" class="btn" :disabled="pageNumber <= 1" @click="prevPage">{{ $t('previousPage') }}</button>
                  <span class="current-page">{{ pageNumber }}</span>
                  <button type="button" class="btn" :disabled="(from + size) >= total" @click="nextPage">{{ $t('nextPage') }}</button>
                </div>
              </template>
              <template v-else>
                <div class="row">
                  <div class="col-12 no_result mt-5">{{ $t('noResult') }}</div>
                </div>
              </template>
            </template>
            <template v-else>
              <div class="w-100 h-100 d-flex justify-content-center align-items-center">
                <spinner size="large"></spinner>
              </div>
            </template>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { PACKAGE } from '../../../package_constants'
import Navbar from '../../misc/components/./Navbar'

export default {
  name: 'employerBoard',
  components: {
    Navbar
  },
  data () {
    return {
      isResultsLoaded: false,
      isSortPanelOpen: false,
      results: [],
      total: 0,
      from: 0,
      pageNumber: 1,
      size: 10,
      searchTerms: '',
      selectedSortName: 'Title',
      sorts: [
        { name: 'Title', labelKey: 'title' },
        { name: 'Jobs', labelKey: 'jobs' }
      ],
      avatarColors: ['#e08a4a', '#3d5a99', '#9b8ac4', '#4a7c8c']
    }
  },
  computed: {
    ...mapState({
      'bookmarks': state => state.explore.bookmarks,
      'enabledFeatures': state => state.dashboard.enabledFeatures,
      'userObj': state => state.login.userObj
    }),
    isBookmarkEnabled () {
      let bookmarkFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.BOOKMARK_FEATURE_ID]
      return !!(bookmarkFeature && bookmarkFeature.enabled)
    }
  },
  mounted () {
    this.setupBoard()
  },
  methods: {
    ...mapActions([
      'loadUserObj',
      'searchAssociatedEmployers',
      'loadCreateBookmarks',
      'loadDeleteBookmark',
      'loadAllBookmarks'
    ]),
    async setupBoard () {
      this.isResultsLoaded = false
      await this.loadUserObj()
      await this.loadAllBookmarks()
      this.loadEmployers()
    },
    openSortPanel () {
      this.isSortPanelOpen = true
    },
    sortOkClicked () {
      this.isSortPanelOpen = false
      this.sortCurrentPage()
    },
    searchButtonClicked () {
      this.from = 0
      this.pageNumber = 1
      this.loadEmployers()
    },
    loadEmployers () {
      this.isResultsLoaded = false
      let page = this.pageNumber - 1
      if (page < 0) {
        page = 0
      }
      this.searchAssociatedEmployers({
        page: page,
        count: this.size,
        title: this.searchTerms
      }).then((result) => {
        if (result && result.content) {
          this.results = result.content
          this.total = result.totalElements || 0
          this.pageNumber = (result.number || 0) + 1
          this.from = (this.pageNumber - 1) * this.size
          if (this.results.length === 0 && this.total > 0 && page > 0) {
            this.pageNumber = 1
            this.from = 0
            this.loadEmployers()
            return
          }
          this.sortCurrentPage()
        } else {
          this.results = []
          this.total = 0
        }
        this.isResultsLoaded = true
      }).catch(() => {
        this.results = []
        this.total = 0
        this.isResultsLoaded = true
      })
    },
    sortCurrentPage () {
      if (!this.results || this.results.length === 0) {
        return
      }
      if (this.selectedSortName === 'Jobs') {
        this.results.sort((a, b) => {
          return this.jobPostedCount(b) - this.jobPostedCount(a)
        })
      } else {
        this.results.sort((a, b) => {
          return (a.displayName || '').localeCompare(b.displayName || '')
        })
      }
    },
    jobPostedCount (result) {
      if (!result || result.jobPosted === undefined || result.jobPosted === null || result.jobPosted === '') {
        return 0
      }
      return result.jobPosted
    },
    goToEmployerDetail (result) {
      if (result && result.uuid) {
        this.$router.push({
          name: 'employerDetails',
          params: { uuid: result.uuid },
          query: { jobs: this.jobPostedCount(result) }
        })
      }
    },
    prevPage () {
      if (this.pageNumber > 1) {
        this.pageNumber = this.pageNumber - 1
        this.from = (this.pageNumber - 1) * this.size
        this.loadEmployers()
      }
    },
    nextPage () {
      if ((this.from + this.size) < this.total) {
        this.pageNumber = this.pageNumber + 1
        this.from = (this.pageNumber - 1) * this.size
        this.loadEmployers()
      }
    },
    employerInitials (title) {
      if (!title) {
        return ''
      }
      let first = title.trim().split(/\s+/)[0]
      if (first.length <= 4) {
        return first.toUpperCase()
      }
      return first.substring(0, 3).toUpperCase()
    },
    avatarColor (index) {
      return this.avatarColors[index % this.avatarColors.length]
    },
    async toggleEmployerBookmark (employer) {
      if (this.isEmployerBookmark(employer)) {
        await this.deleteEmployerBookmark(employer)
      } else {
        await this.bookmarkEmployer(employer)
      }
    },
    async bookmarkEmployer (employer) {
      const bookmark = {
        'source': 'explore',
        'entityType': 'employer',
        'entityTitle': employer.displayName,
        'entityUuid': employer.uuid,
        'institutionId': this.userObj.institutionId,
        'userId': this.userObj.uuid
      }
      const response = await this.loadCreateBookmarks(bookmark)
      const message = (response ? this.$t('successfullyBookmarked') : this.$t('unableToBookmark')) + ' \'' + employer.displayName + '\''
      if (response) {
        this.notifySuccess(message)
      } else {
        this.notifyFailure(message)
      }
      await this.loadAllBookmarks()
    },
    async deleteEmployerBookmark (employer) {
      await this.loadDeleteBookmark(employer.bookmark.uuid)
      this.notifySuccess(this.$t('successfullyDeletedBookmark') + ' \'' + employer.displayName + '\'')
      await this.loadAllBookmarks()
    },
    isEmployerBookmark (employer) {
      let bookmarks = this.bookmarks
      if (!bookmarks || !bookmarks.length) {
        return false
      }
      let target = false
      bookmarks.forEach(bookmark => {
        if (bookmark.entityUuid === employer.uuid && bookmark.entityType === 'employer') {
          target = bookmark
          employer.bookmark = bookmark
        }
      })
      return target
    },
    notifySuccess (text) {
      return this.$notify({
        group: 'notify',
        type: 'success',
        title: '',
        text: text
      })
    },
    notifyFailure (text) {
      return this.$notify({
        group: 'notify',
        type: 'error',
        title: '',
        text: text
      })
    }
  }
}
</script>

<style scoped>
  .job-result-row {
    padding: 12px 16px;
    border-bottom: 1px solid #e6e6e6;
    background: #fff;
  }
  .job-title-row {
    display: flex;
    align-items: flex-start;
    margin-bottom: 8px;
  }
  .job-title {
    flex: 1;
    font-weight: 500;
    color: #4a4a4a;
  }
  .ic_bm_container {
    margin-left: 8px;
  }
  .ic_bm_container.bookmarked {
    color: #3d5a99;
  }
  .job-employer {
    display: flex;
    align-items: center;
  }
  .employer-job-count {
    display: flex;
    align-items: center;
    color: #6b6b6b;
    font-size: 13px;
  }
  .employer-job-count .meta-icon {
    margin-right: 6px;
    font-size: 16px;
    color: #4a4a4a;
  }
  .employer-avatar {
    width: 72px;
    height: 28px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 10px;
    color: #000;
    font-weight: 600;
    overflow: hidden;
    flex-shrink: 0;
  }
  .employer-avatar.has-logo {
    background: transparent;
  }
  .employer-avatar img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  .job-pagination {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px;
    gap: 16px;
  }
  .job-pagination .btn {
    color: #fff;
  }
  .job-pagination .btn:disabled {
    color: #fff;
    opacity: 1;
  }
  .current-page {
    min-width: 24px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/app/employer/components/EmployerBoard.vue